import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {SafeSubscriberDirective} from '../../../../application/app-context/safe-subscriber.directive';
import {Advertising} from '../../../../domain/advertising/model/advertising';
import {AdvertisingService} from '../../../../domain/advertising/service/advertising-service';
import {AnalyticsCategory} from '../../../../application/analytics/analytics-category';
import {AmplitudeService} from '../../../../application/analytics/service/amplitude.service';
import {StringUtils} from '../../../utils/string.utils';

@Component({
             selector: 'app-advertising-dialog',
             templateUrl: './advertising-dialog.component.html',
             styleUrls: ['./advertising-dialog.component.scss']
           })
export class AdvertisingDialogComponent extends SafeSubscriberDirective implements OnInit {

  advertising: Advertising;
  isPreview: boolean;

  constructor(public dialogRef: MatDialogRef<AdvertisingDialogComponent>,
              private advertisingService: AdvertisingService,
              public dialog: MatDialog,
              private amplitudeService: AmplitudeService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    this.advertising = data.advertising;
    this.isPreview = data.isPreview ? data.isPreview : false;
  }

  ngOnInit(): void {
    this.subs.push(
      this.dialogRef.beforeClosed().subscribe(() => {
        this.markAdvertisingAsReadForCurrentUserAndClose();
      })
    );
  }

  markAdvertisingAsReadForCurrentUserAndClose(): void {
    if (!this.isPreview) {
      this.subs.push(
        this.advertisingService.read(this.advertising.id).subscribe(() => {
          this.dialogRef.close();
        })
      );
    } else {
      this.dialogRef.close();
    }
  }

  redirectToLink(): void {
    if (!this.isPreview) {
      const eventProperties = new Map<string, string>();
      eventProperties.set('Action', this.buildAnalyticEvent(this.advertising.title));
      this.amplitudeService.trackEventAction(AnalyticsCategory.advertising, '', eventProperties);
    }
    window.open(this.advertising.actionBtLink, '_blank');
  }

  private buildAnalyticEvent(title: string): string {
    return AnalyticsCategory.publicite + '_' +
           StringUtils.getStringTransformer(title)
                      .cleanAccents()
                      .capitalizeFirstLetters()
                      .toSnakeCase()
                      .build();
  }
}
